import type { ReactNode } from "react";

import { createContext, useState, useEffect, useContext } from "react";

type TTheme = "light" | "dark";

interface IThemeContext {
  theme: TTheme;
  toggleTheme: () => void;
}

interface IThemeProviderProps {
  children: ReactNode;
}

const ThemeContext = createContext<IThemeContext | undefined>(undefined);

export function ThemeProvider({ children }: IThemeProviderProps) {
  // const getInitialTheme = (): TTheme => {
  //   const savedTheme = localStorage.getItem("app-theme") as TTheme | null;
  //   if (savedTheme) {
  //     return savedTheme;
  //   }

  //   const prefersDark = window.matchMedia(
  //     "(prefers-color-scheme: dark)"
  //   ).matches;

  //   return prefersDark ? "dark" : "light";
  // };

  const [theme, setTheme] = useState<TTheme>("light");

  useEffect(() => {
    const root = document.documentElement;

    root.setAttribute("data-bs-theme", theme);

    localStorage.setItem("app-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const contextValue: IThemeContext = { theme, toggleTheme };

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme(): IThemeContext {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within ThemeProvider");
  }

  return context;
}
